import { Injectable } from '@angular/core'
import { MbSalutationAdapter } from './mb-salutation.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbSalutationConnector {

  constructor (protected adapter: MbSalutationAdapter) {
  }

  get () {
    return this.adapter.load()
  }
}
